<template>
  <router-link
    :to="{
      path: `/blog/${post.attributes.slug}`,
      hash: 'enter',
    }"
    rel="canonical"
    class="title-link"
  >
    <div class="blog-post-card">
      <img
        class="image"
        :src="getImageUrl(post.attributes.coverImage)"
        :alt="post.attributes.title"
      />
      <div class="content">
        <div class="text-content">
          <div class="date title-link">
            {{ new Date(post.attributes.createdAt).toLocaleDateString() }}
          </div>
          <div class="title-link">
            <div class="titles">
              {{ post.attributes.title }}
            </div>
            <div class="excerpt">{{ post.attributes.excerpt }}</div>
          </div>
        </div>
        <div class="tags" v-if="post.attributes.tags">
          <router-link
            v-for="tag in post.attributes.tags.data"
            :key="tag.id"
            :to="{
              path: `/blog/tag/${tag.attributes.slug}`,
              hash: 'enter',
            }"
            class="p-button"
          >
            <span class="tag">{{ tag.attributes.name }}</span></router-link
          >
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: "BlogPostCard",
    props: ["post"],
    methods: {
      getImageUrl(coverImage) {
        return `${process.env.VUE_APP_API_URL}${coverImage.data.attributes
          .formats?.small?.url || coverImage.data.attributes.url}`;
      },
    },
    mounted() {},
  };
</script>

<style lang="scss">
  .title-link {
    text-decoration: none !important;
    &:hover {
      color: rgba(42, 46, 71, 0.747);
    }
  }
  .blog-post-card {
    background: white;
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
    // background: rgba(245, 245, 244, 0.44);
    backdrop-filter: blur(20px);
    border-radius: 12px;
    height: 100%;
    &:hover {
      box-shadow: 1px 1px 30px 0px rgba(176, 176, 176, 0.75);
      -webkit-box-shadow: 1px 1px 30px 0px rgba(176, 176, 176, 0.75);
      -moz-box-shadow: 1px 1px 30px 0px rgba(176, 176, 176, 0.75);
    }
    .image {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      object-fit: cover;
      width: 100%;
      max-height: 200px;
      max-width: 100%;
    }
    .content {
      display: flex;
      flex-direction: column;
      padding: 10px;
      height: 100%;
      justify-content: space-between !important;
      .text-content {
        display: flex;
        flex-direction: column;
        .date {
          font-size: 14px;
        }
        .title-link {
          text-decoration: none !important;
          &:hover {
            color: rgba(42, 46, 71, 0.747);
          }
        }
        .titles {
          margin-top: 5px;
          margin-bottom: 10px;
          font-weight: 600;
        }
        .excerpt {
          font-size: 14px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }

      .tags {
        display: flex;
        flex-wrap: wrap;
        a {
          text-decoration: none;
          white-space: nowrap;
          margin-top: 15px;
        }
        .tag {
          margin-right: 5px;
          font-size: 13px;
          padding: 5px;
          background-color: #2424fc;
          color: white;
          border-radius: 8px;
          &:hover {
            background-color: #3152f6;
          }
        }
      }
    }
  }
</style>
